<template>
  <div id="blade2a">
    <TwelveCol class="doom-slayer"></TwelveCol>
    <GroupContainer class="blade-2a-group-cntnr num-cntnr-width" :obj="stObj.gC">
      <template #slot1>
        <TwelveCol>
          <template #slot1>
            <EightByFour :obj="stObj.eBF1">
              <template #slot1>
                <div class="revealText"></div>
                <div>
                  <h2
                    data-aos-anchor=".revealText"
                    data-aos="fade-left"
                    data-aos-delay="500"
                    class="blade-2a-main-title"
                    v-html="stObj.title"
                  ></h2>
                </div>
              </template>
              <template #slot2>
                <div class="content-container">
                  <div data-aos="fade-up" data-aos-delay="750" data-aos-anchor=".revealText">
                    <p
                      class="content"
                      v-for="(p, index) in stObj.paragraphs"
                      v-html="p"
                      :key="`blade2a-p-${index}`"
                    ></p>
                  </div>
                </div>
              </template>
            </EightByFour>
          </template>
        </TwelveCol>
      </template>
    </GroupContainer>
  </div>
</template>

<script>
import EightByFour from "../../../2019-immersive-modular-experience/src/components/EightByFour";
import GroupContainer from "../../../2019-immersive-modular-experience/src/components/GroupContainer";
import TwelveCol from "../../../2019-immersive-modular-experience/src/components/TwelveCol";
import { inView } from "../../helpers/inView";
import bladeAnimations from "../../helpers/bladeAnimations";

export default {
  name: "Blade2a",
  components: {
    EightByFour,
    GroupContainer,
    TwelveCol
  },
  data: function() {
    return {
      hasAnimated: false
    };
  },
  computed: {
    stObj() {
      return this.$store.state.blade2a;
    }
  },
  methods: {
    checkInView() {
      if (!this.hasAnimated) {
        this.hasAnimated = inView(
          ".doom-slayer",
          bladeAnimations.blade2.doomSlayer,
          "mid"
        );
      } else {
        document.removeEventListener("scroll", this.checkInView);
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      bladeAnimations.parallax(".doom-slayer");
      document.addEventListener("scroll", this.checkInView);
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/blade2a.scss";
</style>
